import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { TreeNode } from 'src/app/orgChart/common/treenode';
import { SiteService } from '../../../../services/site.service';
import { UtilitiesService } from '../../../../services/utilities.service';
import { LoadService } from '../../../../services/load.service';
import { Subscription, Observable, of, Subject, timer } from 'rxjs';
import { Router, RouterLink, ActivatedRoute, ParamMap } from '@angular/router';
import { Constants, API_BASE$ } from 'src/app/shared/index';
import * as moment from 'moment';
import { CommonService } from 'src/app/services';
@Component({
  selector: 'app-inverter-view',
  templateUrl: './inverter-view.component.html',
  styleUrls: ['./inverter-view.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class InverterViewComponent implements OnInit, OnDestroy {

  loadONTreeData: TreeNode[];
  selectedNode: TreeNode;
  private nodesList = new Map();
  nodeLevel = 1;
  siteId: string;
  apiData: any;
  subscription: Subscription;
  loadSubscription: Subscription;

  inverterTreeNodesConnStatus = [];
  inverterTreeNodesPowerInfo = [];
  inverterTreeNodesDCPowerInfo = [];
  meterIdsForLoadONTree = [];
  metersForLoadONTree = [];
  inverterStatusInfo = [];
  inverterInterval = 30;		// 30 seconds
  intervalForInverter = undefined;
  loadOnTreeLastF5Timestamp = undefined;
  sensorHealth = '';
  sensorHealthMsg = '';

  sensorHealthParamsAtDashboardLevel: any;
  firstTime = true;
  baseUrlFirst: String;
  baseUrl: string;
  baseUrlChild: string
  interval: any;
  resStatus: boolean;
  constructor(private activeRoute: ActivatedRoute, private siteService: SiteService,
    private utilitiesService: UtilitiesService, private loadService: LoadService,
    private commonService: CommonService,) {
    this.loadONTreeData = [];
    this.nodesList = new Map();
    // this.baseUrl = this.baseUrl.substring(0, this.baseUrl.length - 1);
    this.siteId = this.activeRoute.snapshot.queryParams['siteId']; // 'JAPBOSCH30201064';
    this.sensorHealthParamsAtDashboardLevel = {
      'Level': 'Dashboard',
      'SiteID': this.siteId,
      'Role': 'Solar'
    };
    this.getTreeConfiguration(this.siteId);

  }

  public ngOnInit() {
    if (this.loadSubscription) {
      this.loadSubscription.unsubscribe();
    }
    this.interval = setInterval(() => {
      console.log("Refresh");
      this.inverterTreeNodesConnStatus = [];
      this.inverterTreeNodesPowerInfo = [];
      this.inverterTreeNodesDCPowerInfo = [];
      this.inverterStatusInfo = [];
      this.getMetersStatus(false);
    }, 60000);
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    clearInterval(this.interval);
  }
  onNodeSelect(event) {
  }


  parseTreeData(root, parent, nodeLevel: number) {
    return new Promise((resolve, reject) => {
      const t = this;
      const item: TreeNode = {};

      item.label = root.title;
      item.data = root;
      item.expanded = true;
      item.showInVertical = root.showInVertical != null ? root.showInVertical : false;
      if (parent === null) {

        item.type = 'person';
        item.styleClass = 'ui-person';
        t.loadONTreeData.push(item);
      } else {
        const level = this.nodesList.get(root.id);

        if (level === 2) {
          item.type = 'nodeLevel2';
          item.styleClass = 'ui-nodeLevel2';
        }
        if (level > 2) {
          item.type = 'nodeLevel3';
          item.styleClass = 'department-cto';
        }
        if (parent.children === undefined || parent.children.length <= 0) {
          parent.children = [];
        }
        parent.children.push(item);

      }

      if (root.nodes != null && root.nodes.length > 0) {
        item.children = [];
        t.nodeLevel = t.nodeLevel + 1;
        root.nodes.forEach(function (n) {
          t.nodesList.set(n.id, t.nodeLevel);
        });
        const nodes = root.nodes;
        for (const iterator of nodes) {
          this.parseTreeData(iterator, item, t.nodeLevel);
        }
      }
      resolve(true);
    });
  }

  getTreeConfiguration(siteId: string) {
    const t = this;

    this.siteService.getTreeConfiguration(siteId, ['inverterTreeData']).subscribe(
      data => {
        if (data.inverterTreeData !== null && data.inverterTreeData !== undefined) {
          t.apiData = JSON.parse(data.inverterTreeData);

          const promise = t.parseTreeData(t.apiData[0], null, this.nodeLevel);
          promise.then((val) => {
            let loadRIds = [];
            for (let i = 0; i < t.loadONTreeData.length; i++) {
              t.getLoadRIdsFromNode(t.loadONTreeData[i].data, loadRIds);
            }
            loadRIds = t.utilitiesService.uniqueArray(loadRIds);
            t.meterIdsForLoadONTree = [];
            let loadids = [];
            loadids = loadRIds;
            t.loadService.getMetersOfLoads({ loadids }).subscribe(meters => {
              t.metersForLoadONTree = meters;
              for (let i = 0; i < meters.length; i++) {
                t.meterIdsForLoadONTree.push(meters[i].meterId);
              }
              t.getMetersStatus(false);

              t.intervalForInverter = timer(0, t.inverterInterval * 1000);
              this.subscription = t.intervalForInverter.subscribe(() => {
                // console.log('getMetersStatus-time:' + moment().toString());
                t.getMetersStatus(true);
              });
            });
          })
            .catch((val) => console.log(val));

        }
      }
    );
  }

  getNodeDetailInfo() {
    const t = this;
    let loadRIds = [];
    for (let i = 0; i < t.loadONTreeData.length; i++) {
      t.getLoadRIdsFromNode(t.loadONTreeData[i], loadRIds);
    }
    loadRIds = t.utilitiesService.uniqueArray(loadRIds);
    t.meterIdsForLoadONTree = [];

    t.loadService.getMetersOfLoads(loadRIds).subscribe(meters => {
      t.metersForLoadONTree = meters;
      for (let i = 0; i < meters.length; i++) {
        t.meterIdsForLoadONTree.push(meters[i].meterId);
      }
      t.getMetersStatus(false);

      t.intervalForInverter = timer(0, t.inverterInterval * 1000);
      this.subscription = t.intervalForInverter.subscribe(() => {
        t.getMetersStatus(true);
      });
    });
  }

  getLoadRIdsFromNode(node, loadRIds) {
    const t = this;
    if (node.loadId !== undefined) {
      loadRIds.push(node.loadId);
    }
    // console.log(node);
    if (node.nodes !== undefined && node.nodes !== null) {
      for (let i = 0; i < node.nodes.length; i++) {
        t.getLoadRIdsFromNode(node.nodes[i], loadRIds);
      }
    }
  }

  getMetersStatus(hideLoading) {
    const t = this;
    let model = {};
    //t.getSensorHealth(t.sensorHealthParamsAtDashboardLevel);

    model = { siteId: t.siteId, meterIds: t.meterIdsForLoadONTree };
    t.loadService.getMetersStatus(model, hideLoading).subscribe(metersStatusData => {
      for (let i = 0; i < t.metersForLoadONTree.length; i++) {
        t.inverterTreeNodesConnStatus.push({
          rId: t.metersForLoadONTree[i].loadID,
          status: metersStatusData[t.metersForLoadONTree[i].meterId]
        });
      }
    });
    const powerModel = { siteId: t.siteId, meterIds: t.meterIdsForLoadONTree, parameter: 'power' };
    t.loadService.getParamValueForMeters(powerModel).subscribe(metersPowerData => {
      for (let i = 0; i < t.metersForLoadONTree.length; i++) {
        t.inverterTreeNodesPowerInfo.push({
          rId: t.metersForLoadONTree[i].loadID,
          power: metersPowerData[t.metersForLoadONTree[i].meterId]
        });
      }
    });
    const dcPowerModel = { siteId: t.siteId, meterIds: t.meterIdsForLoadONTree, parameter: 'DCpower' };
    t.loadService.getParamValueForMeters(dcPowerModel).subscribe(metersDCPowerData => {
      for (let i = 0; i < t.metersForLoadONTree.length; i++) {
        t.inverterTreeNodesDCPowerInfo.push({
          rId: t.metersForLoadONTree[i].loadID,
          dcpower: metersDCPowerData[t.metersForLoadONTree[i].meterId]
        });
      }
    });
    const statusModel = { siteId: t.siteId, meterIds: t.meterIdsForLoadONTree };
    t.loadService.getInvertersFaultStatus(statusModel).subscribe(statusData => {
      for (let i = 0; i < t.meterIdsForLoadONTree.length; i++) {
        t.inverterStatusInfo.push({
          rId: t.meterIdsForLoadONTree[i],
          status: statusData[t.meterIdsForLoadONTree[i]]
        });
      }
    });
    t.loadOnTreeLastF5Timestamp = new Date();
  }
  // Get SensorHealth
  // getSensorHealth(sensorHealthParams) {
  //   const t = this;
  //   t.loadService.getSensorHealthBasedOnLevel(sensorHealthParams).subscribe(data => {
  //     // Received Map - Criticality, No Of Open alerts
  //     if (data.High > 0) {
  //       t.sensorHealth = Constants.SENSOR_HEALTH.OFF;
  //       t.sensorHealthMsg = Constants.SENSOR_HEALTH.NOT_OK;
  //     } else if (data.Medium > 0) {
  //       t.sensorHealth = Constants.SENSOR_HEALTH.NA;
  //       t.sensorHealthMsg = Constants.SENSOR_HEALTH.NOT_OK;
  //     } else {
  //       t.sensorHealth = Constants.SENSOR_HEALTH.ON;
  //       t.sensorHealthMsg = Constants.SENSOR_HEALTH.OK;
  //     }
  //     console.log('data --> ' + JSON.stringify(data));
  //   });
  // }

  getLoadPower(loadId) {
    const t = this;
    let power = 0;
    for (let i = 0; i < t.inverterTreeNodesPowerInfo.length; i++) {
      if (t.inverterTreeNodesPowerInfo[i].rId === loadId) {
        power = t.inverterTreeNodesPowerInfo[i].power;
        if (power === undefined) {
          power = 0;
        }
        break;
      }
    }
    return power;
  }

  getNodePower(node) {
    const t = this;
    let nodePower = 0;
    if (node.nodes == undefined || node.nodes == null || node.nodes.length === 0) {
      if (node.nodeType === Constants.NODE_TYPE.LOAD
        || node.loadId !== undefined) {
        nodePower = t.getLoadPower(node.loadId);
      }
    } else {
      for (let i = 0; i < node.nodes.length; i++) {
        const childPower = t.getNodePower(node.nodes[i]);
        nodePower += childPower;
      }
    }
    return nodePower;
  }

  getNodeClass(node) {
    let attachementId = '';
    if (node.nodeImg !== undefined) {
      attachementId = node.nodeImg.id;
      this.baseUrl = this.commonService.getSolarNodeImageUrl(this.siteId, attachementId);
    }
    const classON = Constants.MACHINE.Label_Machine_ON;
    const classOFF = Constants.MACHINE.Label_Machine_OFF;
    const classNA = Constants.MACHINE.Label_Data_NA;
    const nodeStatus = this.getNodeStatus(node);
    const nodeClass = (nodeStatus === Constants.SENSOR_HEALTH.ON ? classON
      : (nodeStatus === Constants.SENSOR_HEALTH.OFF ? classOFF : classNA));
    return nodeClass;
  }

  getLoadStatus(loadId) {
    let status = Constants.SENSOR_HEALTH.NA;
    for (let i = 0; i < this.inverterTreeNodesConnStatus.length; i++) {
      if (this.inverterTreeNodesConnStatus[i].rId === loadId) {
        status = this.inverterTreeNodesConnStatus[i].status;
        break;
      }
    }
    return status;
  }

  getNodeStatus = function (node) {
    let nodeStatus = Constants.SENSOR_HEALTH.NA;
    if (node.nodes == undefined || node.nodes == null || node.nodes.length === 0) {
      if (node.nodeType === Constants.NODE_TYPE.LOAD
        || node.loadId !== undefined) {
        nodeStatus = this.getLoadStatus(node.loadId);
      }
    } else {
      for (let i = 0; i < node.nodes.length; i++) {
        const childStatus = this.getNodeStatus(node.nodes[i]);
        if (childStatus === Constants.SENSOR_HEALTH.ON) {
          nodeStatus = Constants.SENSOR_HEALTH.ON;
          break;
        } else if (childStatus === Constants.SENSOR_HEALTH.OFF) {
          nodeStatus = Constants.SENSOR_HEALTH.OFF;
        }
      }
    }
    return nodeStatus;
  };

  getInverterLoadPower(loadId) {
    const t = this;
    let power = 0;
    for (let i = 0; i < t.inverterTreeNodesPowerInfo.length; i++) {
      if (t.inverterTreeNodesPowerInfo[i].rId === loadId) {
        power = t.inverterTreeNodesPowerInfo[i].power;
        if (power === undefined) {
          power = 0;
          this.resStatus = false;
        }
        else {
          this.resStatus = true;
        }
        break;
      }
    }
    return power;
  }

  getInverterPower(node) {
    const t = this;
    let attachementId = '';
    let nodePower = 0;
    if (node !== undefined && node !== null) {
      if (node.nodeImg !== undefined) {
        attachementId = node.nodeImg.id;
        this.baseUrlChild = this.commonService.getSolarNodeImageUrl(this.siteId, attachementId);
      }
      if (node.nodeType === Constants.NODE_TYPE.LOAD
        || node.loadId !== undefined) {
        nodePower = t.getInverterLoadPower(node.loadId);
      }
    }
    return nodePower;
  }

  getNodeACOutClass(node) {
    const classON = Constants.MACHINE.Label_Machine_ON;
    const classOFF = Constants.MACHINE.Label_Machine_OFF;
    const classNA = Constants.MACHINE.Label_Data_NA;
    const nodeStatus = this.getNodeACOutStatus(node);
    const nodeClass = (nodeStatus === Constants.SENSOR_HEALTH.ON ? classON
      : (nodeStatus === Constants.SENSOR_HEALTH.OFF ? classOFF : classNA));
    return nodeClass;
  }

  getNodeACOutStatus(node) {
    let nodeStatus = Constants.SENSOR_HEALTH.NA;
    const nodePower = this.getInverterPower(node);

    if (nodePower > 0) {
      nodeStatus = Constants.SENSOR_HEALTH.ON;
    } else if (nodePower == 0 && this.resStatus == true) {
      nodeStatus = Constants.SENSOR_HEALTH.OFF;
    }
    else {
      nodeStatus = Constants.SENSOR_HEALTH.NA;
    }
    return nodeStatus;
  }

  // getting dc power for inverters
  getLoadDCPower(loadId) {
    let dcpower = 0;
    for (let i = 0; i < this.inverterTreeNodesDCPowerInfo.length; i++) {
      if (this.inverterTreeNodesDCPowerInfo[i].rId === loadId) {
        dcpower = this.inverterTreeNodesDCPowerInfo[i].dcpower;
        if (dcpower === undefined) {
          dcpower = 0;
        }
        break;
      }
    }
    return dcpower;
  }

  getNodeDCPower(node) {
    const t = this;
    let nodedcPower = 0;
    if (node !== undefined && node !== null) {
      if (node.nodeType === Constants.NODE_TYPE.LOAD
        || node.loadId !== undefined) {
        nodedcPower = t.getLoadDCPower(node.loadId);
      }
    }
    return nodedcPower;
  }
  //Get Inverter Fault Status

  getInverterStatus(meterId) {
    const t = this;
    let defstatus = Constants.INVERTER_STATUS.NA;
    for (let i = 0; i < t.inverterStatusInfo.length; i++) {
      if (t.inverterStatusInfo[i].rId === meterId) {
        defstatus = t.inverterStatusInfo[i].status;
        break;
      }
    }
    return defstatus;
  }
  getInverterFault(node) {
    const inverterOK = Constants.INVERTER_STATUS.OK;
    const inverterFaulty = Constants.INVERTER_STATUS.Faulty;
    const inverterNA = Constants.MACHINE.Label_Data_NA;
    const nodeStatus = this.getInverterFaultStatus(node);
    const nodeClass = (nodeStatus === Constants.INVERTER_STATUS.OK ? inverterOK
      : (nodeStatus === Constants.INVERTER_STATUS.Faulty ? inverterFaulty : inverterNA));
    return nodeClass;
  }

  getInverterFaultStatus = function (node) {
    let nodeStatus = Constants.INVERTER_STATUS.NA;
    nodeStatus = this.getInverterStatus(node.meterId);
    if (nodeStatus === Constants.INVERTER_STATUS.OK) {
      nodeStatus = Constants.INVERTER_STATUS.OK;
    }
    else if (nodeStatus === Constants.INVERTER_STATUS.Faulty) {
      nodeStatus = Constants.INVERTER_STATUS.Faulty;
    }
    return nodeStatus;
  };
}